// Home.js
import React from 'react';
import Lists from '../components/list';
import Header from '../components/Header';
import Footer from '../components/Footer';

const List = () => {
 
  return (
    <>
      <Header />
      <Lists />
      <Footer />
    </>
  );
};

export default List;
